import { Contract } from '@enechain/eposition-proto/bffcommon/v1/eex_model_pb'

import {
  SimulationOrderPatternModel,
  convertSimulationOrderPatternModel,
} from '~/pages/Simulation/models/SimulationOrderPattern'
import {
  OrderSimulationSchema,
  createValidatedOrderPatternSchema,
} from '~/pages/Simulation/schemas'

// first class collection of  SimulationOrderPatternModel
export type SimulationOrderPatternModels = {
  models: SimulationOrderPatternModel[]
}

type SimulationType = 'MARGIN' | 'DEAL_AVAILABLE'

function getTargetOrders(
  orderSimulation: OrderSimulationSchema,
  simulationType: SimulationType,
): Set<number> {
  switch (simulationType) {
    case 'MARGIN': {
      const allValues = orderSimulation.marginSimulationRelation.flatMap(
        (relation) => relation.values,
      )
      return new Set(allValues)
    }
    case 'DEAL_AVAILABLE':
      return new Set(orderSimulation.availableDealSimulationRelation)
    default:
      return new Set()
  }
}

export function convertToSimulationOrderPatternModels(
  orderSimulation: OrderSimulationSchema,
  simulationType: SimulationType,
  eexContracts: Contract[] = [],
): { orderPatternModels?: SimulationOrderPatternModels; error?: string } {
  const models: SimulationOrderPatternModel[] = []
  const targetOrders = getTargetOrders(orderSimulation, simulationType)
  for (const [index, order] of orderSimulation.orderPattern.entries()) {
    if (!targetOrders.has(index + 1)) {
      continue
    }
    const result = createValidatedOrderPatternSchema(
      !order.isPhysicalFuture,
    ).safeParse(order)
    if (!result.success) {
      return { error: result.error.message }
    }
    const { model, error } = convertSimulationOrderPatternModel(
      result.data,
      index,
      eexContracts,
    )
    if (error !== undefined) {
      return { error }
    }
    if (model !== undefined) {
      models.push(model)
    }
  }
  return { orderPatternModels: { models } }
}
